import { render, staticRenderFns } from "./Postedetravail.vue?vue&type=template&id=4af9a46c&"
import script from "./Postedetravail.vue?vue&type=script&lang=js&"
export * from "./Postedetravail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports